import { FolderGit2 } from 'lucide-react'
import { useI18n } from '../lib/i18n'
import type { ProjectFilter } from '../lib/projectFilter'

/**
 * Which project the floor shows: all of them, each agent labelled with its own, or one. Sits beside
 * the team picker and wears the same coat. Draws nothing when there is no project to choose.
 */
export function ProjectPicker({ filter, className }: { filter: ProjectFilter; className?: string }) {
  const { t } = useI18n()
  if (!filter.show) return null

  return (
    <label className={`team-picker${className ? ` ${className}` : ''}`} title={t('projectPicker.label')}>
      <FolderGit2 size={13} aria-hidden />
      <select
        className="team-picker__select"
        value={filter.projectId ?? ''}
        onChange={(event) => filter.setProjectId(event.target.value || undefined)}
        aria-label={t('projectPicker.label')}
      >
        <option value="">{t('projectPicker.all')}</option>
        {filter.projects.map((project) => (
          <option key={project.id} value={project.id}>
            {project.name === project.key ? project.name : `${project.name} (${project.key})`}
          </option>
        ))}
      </select>
    </label>
  )
}
